import { styled } from "@mui/material/styles";
import PhoneMobileComponent from "./phone-mobile.svg";
import PhoneComponent from "./phone.svg";
import PhoneLottieComponent from "./phone-lottie.svg";
import StaticPhoneComponent from "./filler.svg";
import { Lottie as LottieComponent } from "components/lottie";

export const Container = styled("div", {
  label: "art",
})`
  position: relative;
  align-items: center;
  height: 100%;

  ${({ theme }) => theme.breakpoints.up("md")} {
    height: 80%;
  }
`;

export const PhoneMobileView = styled(PhoneMobileComponent, {
  label: "phone-mobile",
})`
  height: 100%;
  width: 100%;
`;
export const PhoneView = styled(PhoneComponent, {
  label: "phone",
})`
  height: 100%;
`;

export const PhoneLottie = styled(PhoneLottieComponent, {
  label: "phone-lottie",
})`
  height: 100%;
`;

export const Lottie = styled(LottieComponent, {
  label: "lottie",
})`
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
`;

export const LottieContainer = styled("div", {
  label: "lottie-container",
})`
  height: 100%;
`;

export const StaticPhoneContainer = styled("div", {
  label: "static-phone-container",
})`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
`;

export const PhoneContainer = styled("div", {
  label: "phone-container",
})`
  position: relative;
  height: 100%;
  z-index: 2;
`;

export const StaticPhone = styled(StaticPhoneComponent, {
  label: "static-phone",
})`
  height: 100%;
  z-index: 2;
`;
